import {useEffect, useState} from "react";
import {openManagedSSE} from "@modules/realtime/sseClient.js";

export function useSSEStatus(topic = "sys")
{
	const [status, setStatus] = useState("connecting"); // "connecting" | "open" | "error"
	const [reconnects, setReconnects] = useState(0);

	useEffect(() =>
	{
		const API = import.meta.env.VITE_API_URL || "";
		const url = `${API}/api/events?topic=${encodeURIComponent(topic)}`;

		return openManagedSSE(url, {
			onOpen: () => setStatus("open"),
			onError: () =>
			{
				setStatus("error");
				setReconnects(r => r + 1); // il client riconnette con backoff (dopo refresh)
			},
			onFatal: () => setStatus("error")
		});
	}, [topic]);

	return {status, reconnects};
}
